import { View, StyleSheet } from "react-native";
import { useRouter } from "expo-router";
import { Text } from "./components/Text";
import Header from "./components/PickupDriveThru/Header";
import FooterButton from "./components/PickupDriveThru/FooterButton";
import { colors } from "./constants/styles";
import { useTranslateText } from "./utils";

export default function PickupDriveThruVerified() {
  const router = useRouter();
  const { t } = useTranslateText();

  return (
    <View style={styles.container} testID="pickupDriveThruVerifiedContainer">
      <Header showBackButton={false} />
      <View style={styles.content}>
        <Text style={styles.title}>
          {t("tpos.pickupDriveThru.orderVerified")}
        </Text>
        <Text style={styles.message}>
          {t("tpos.pickupDriveThru.orderVerifiedMessage")}
        </Text>
        <View testID="orderVerifiedIcon" style={styles.checkCircle}>
          <Text style={styles.checkMark}>✓</Text>
        </View>
      </View>
      <FooterButton
        testID="mainMenuButton"
        text={t("tpos.pickupDriveThru.mainMenu")}
        // The entry screen was replaced by this one, so back returns home
        onPress={() => router.back()}
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.white,
  },
  content: {
    flex: 1,
    alignItems: "center",
    paddingHorizontal: 24,
    paddingVertical: 32,
    gap: 24,
  },
  title: {
    fontSize: 48,
    fontWeight: "bold",
    color: colors.maroon,
  },
  message: {
    maxWidth: 420,
    fontSize: 16,
    lineHeight: 24,
    textAlign: "center",
    color: colors.maroon,
  },
  checkCircle: {
    width: 150,
    height: 150,
    borderRadius: 75,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.emerald,
  },
  checkMark: {
    fontSize: 96,
    color: colors.white,
  },
});
